import { Action } from '@ngrx/store';
import { Record } from 'src/app/Layouts/admin-dashboard/food-safety-system/documents/document-details/models/records.model';
import {
  DocumentContentDetails,
  DocumentDetails,
  GetDocumentByIdRequestPayload,
  GetDocumentContentByIdRequestPayload,
} from '../state/documents.state';

export enum DocumentsActions {
  GetAllDocuments = '[Documents] Get All Documents',
  GetAllDocumentsSuccess = '[Documents] Get All Documents Success',
  GetAllDocumentsError = '[Documents] Get All Documents Error',
  AddDocuments = '[Documents] Add Documents',
  GetAddDocumentsSuccess = '[Documents] Get Add Documents Success',
  GetAddDocumentsError = '[Documents] Get Add Documents Error',
  ResetAddDocuments = '[Documents] Clear New Add Document',
  ResetEditDocument = '[Documents] Clear Edited Document',
  EditDocuments = '[Documents] Edit Documents',
  GetEditDocumentsSuccess = '[Documents] Get Edit Documents Success',
  GetEditDocumentsError = '[Documents] Get Edit Documents Error',
  DocumentsType = '[Documents] Documents Type',
  GetDocumentsTypeSuccess = '[Documents] Get Documents Type Success',
  GetDocumentsTypeError = '[Documents] Get Documents Type Error',
  GetDocumentsTypeReset = '[Documents] Get Documents Type Reset',
  AddDocumentsType = '[Documents] Add Documents Type',
  AddDocumentsTypeSuccess = '[Documents] Add Documents Type Success',
  AddDocumentsTypeError = '[Documents] Add Documents Type Error',
  GetTypeRecord = '[Documents] Get Type Record',
  GetTypeRecordSuccess = '[Documents] Get Type Record Success',
  GetTypeRecordError = '[Documents] Get Type Record Error',
  GetDocumentsById = '[Documents] Get Document By Id',
  GetDocumentsByIdSuccess = '[Documents] Get Document By Id Success',
  GetDocumentsByIdError = '[Documents] Get Document By Id Error',
  GetDocumentsByIdReset = '[Documents] Get Document By Id Reset',
  GetDocumentContentById = '[Documents] Get Document Content By Id',
  GetDocumentContentByIdSuccess = '[Documents] Get Document Content By Id Success',
  GetDocumentContentByIdError = '[Documents] Get Document Content By Id Error',
  GetDocumentContentByIdReset = '[Documents] Get Document Content By Id Reset',
  GetDocumentCount = '[Documents] Get Document Count',
  GetDocumentCountSuccess = '[Documents] Get Documents Count Success',
  GetDocumentCountError = '[Documents] Get Document Count Error',
  GetDocumentSearch = '[Documents] Get Documents Search ',
  GetDocumentSearchSuccess = '[Documents] Get Documents Search Success',
  GetDocumentSearchError = '[Documents] Get Documents Search Error',
  DownloadDocumentFile = '[Documents] Download Document File ',
  DownloadDocumentFileSuccess = '[Documents] Download Document File Success',
  DownloadDocumentFileError = '[Documents] Download Document File Error',
  DocumentsName = '[Documents] Documents Name',
  GetDocumentsNameSuccess = '[Documents] Get Documents Name Success',
  GetDocumentsNameError = '[Documents] Get Documents Name Error',
  AddDocumentsName = '[Documents] Add Documents Name',
  AddDocumentsNameSuccess = '[Documents] Add Documents Name Success',
  AddDocumentsNameError = '[Documents] Add Documents Name Error',
  GetDocumentImport = '[Documents] Get Document Import',
  GetDocumentImportSuccess = '[Documents] Get Document Import Success',
  GetDocumentImportError = '[Documents] Get Document Import Error',
  ResetUploadedDocuments = '[Documents] Reset Uploaded Documents',
  UploadDocuments = '[Documents] Upload Documents',
  UploadDocumentsSuccess = '[Documents] Upload Documents Success',
  UploadDocumentsError = '[Documents] Upload Documents Error',
  RemoveDocument = '[Documents] Remove Document',
  RemoveDocumentSuccess = '[Documents] Remove Document Success',
  RemoveDocumentError = '[Documents] Remove Document Error',
  GetAllRecords = '[Documents] Get All Records',
  GetAllRecordsSuccess = '[Documents] Get All Records Success',
  GetAllRecordsError = '[Documents] Get All Records Error',
  GetAllRecordsReset = '[Documents] Get All Records Reset',
  AcknowledgeDocument = '[Documents] Acknowledge Documents',
  ErrorAcknowledgeDocument = '[Documents] Acknowledge Documents Error',
  AcknowledgeDocumentSuccess = '[Documents] Acknowledge Documents Success',
  AcknowledgeDocumentReset = '[Documents] Acknowledge Documents Reset'
}

export class GetAllDocuments implements Action {
  public readonly type = DocumentsActions.GetAllDocuments;
  constructor(public payload: any) {}
}
export class GetAllDocumentsSuccess implements Action {
  public readonly type = DocumentsActions.GetAllDocumentsSuccess;
  constructor(public payload: any) {}
}
export class GetAllDocumentsError implements Action {
  public readonly type = DocumentsActions.GetAllDocumentsError;
  constructor(public payload: any) {}
}
export class AddDocuments implements Action {
  public readonly type = DocumentsActions.AddDocuments;
  constructor(public payload: any) {}
}
export class GetAddDocumentsSuccess implements Action {
  public readonly type = DocumentsActions.GetAddDocumentsSuccess;
  constructor(public payload: any) {}
}
export class GetAddDocumentsError implements Action {
  public readonly type = DocumentsActions.GetAddDocumentsError;
  constructor(public payload: any) {}
}

export class ResetAddDocuments implements Action {
  public readonly type = DocumentsActions.ResetAddDocuments;
}
export class ResetEditDocument implements Action {
  public readonly type = DocumentsActions.ResetEditDocument;
}
export class EditDocuments implements Action {
  public readonly type = DocumentsActions.EditDocuments;
  constructor(public payload: any, public param: any) {}
}
export class GetEditDocumentsSuccess implements Action {
  public readonly type = DocumentsActions.GetEditDocumentsSuccess;
  constructor(public payload: any) {}
}
export class GetEditDocumentsError implements Action {
  public readonly type = DocumentsActions.GetEditDocumentsError;
  constructor(public payload: any) {}
}
export class DocumentsType implements Action {
  public readonly type = DocumentsActions.DocumentsType;
  constructor(public payload: any) {}
}
export class GetDocumentsTypeSuccess implements Action {
  public readonly type = DocumentsActions.GetDocumentsTypeSuccess;
  constructor(public payload: any) {}
}
export class GetDocumentsTypeError implements Action {
  public readonly type = DocumentsActions.GetDocumentsTypeError;
  constructor(public payload: any) {}
}
export class GetDocumentsTypeReset implements Action {
  public readonly type = DocumentsActions.GetDocumentsTypeReset;
}
export class AddDocumentsType implements Action {
  public readonly type = DocumentsActions.AddDocumentsType;
  constructor(public payload: any) {}
}
export class AddDocumentsTypeSuccess implements Action {
  public readonly type = DocumentsActions.AddDocumentsTypeSuccess;
  constructor(public payload: any) {}
}
export class AddDocumentsTypeError implements Action {
  public readonly type = DocumentsActions.AddDocumentsTypeError;
  constructor(public payload: any) {}
}
export class GetTypeRecord implements Action {
  public readonly type = DocumentsActions.GetTypeRecord;
  constructor(public payload: any) {}
}
export class GetTypeRecordSuccess implements Action {
  public readonly type = DocumentsActions.GetTypeRecordSuccess;
  constructor(public payload: any) {}
}
export class GetTypeRecordError implements Action {
  public readonly type = DocumentsActions.GetTypeRecordError;
  constructor(public payload: any) {}
}
export class GetDocumentsById implements Action {
  public readonly type = DocumentsActions.GetDocumentsById;
  constructor(public payload: GetDocumentByIdRequestPayload) {}
}
export class GetDocumentsByIdSuccess implements Action {
  public readonly type = DocumentsActions.GetDocumentsByIdSuccess;
  constructor(public payload: DocumentDetails[]) {}
}
export class GetDocumentsByIdError implements Action {
  public readonly type = DocumentsActions.GetDocumentsByIdError;
  constructor(public payload: any) {}
}

export class GetDocumentsByIdReset implements Action {
  public readonly type = DocumentsActions.GetDocumentsByIdReset;
}

export class GetDocumentContentById implements Action {
  public readonly type = DocumentsActions.GetDocumentContentById;
  constructor(public payload: GetDocumentContentByIdRequestPayload) {}
}

export class GetDocumentContentByIdSuccess implements Action {
  public readonly type = DocumentsActions.GetDocumentContentByIdSuccess;
  constructor(public payload: DocumentContentDetails[]) {}
}

export class GetDocumentContentByIdError implements Action {
  public readonly type = DocumentsActions.GetDocumentContentByIdError;
  constructor(public payload: any) {}
}
export class GetDocumentContentByIdReset implements Action {
  public readonly type = DocumentsActions.GetDocumentContentByIdReset;
}

export class GetDocumentCount implements Action {
  public readonly type = DocumentsActions.GetDocumentCount;
  constructor(public payload: any) {}
}
export class GetDocumentCountSuccess implements Action {
  public readonly type = DocumentsActions.GetDocumentCountSuccess;
  constructor(public payload: any) {}
}
export class GetDocumentCountError implements Action {
  public readonly type = DocumentsActions.GetDocumentCountError;
  constructor(public payload: any) {}
}
export class GetDocumentSearchSuccess implements Action {
  public readonly type = DocumentsActions.GetDocumentSearchSuccess;
  constructor(public payload: any) {}
}
export class GetDocumentSearchError implements Action {
  public readonly type = DocumentsActions.GetDocumentSearchError;
  constructor(public payload: any) {}
}
export class GetDocumentSearch implements Action {
  public readonly type = DocumentsActions.GetDocumentSearch;
  constructor(public payload: any, public title: any) {}
}

export class DownloadDocumentFile implements Action {
  public readonly type = DocumentsActions.DownloadDocumentFile;
  constructor(public payload: any) {}
}
export class DownloadDocumentFileSuccess implements Action {
  public readonly type = DocumentsActions.DownloadDocumentFileSuccess;
  constructor(public payload: any) {}
}
export class DownloadDocumentFileError implements Action {
  public readonly type = DocumentsActions.DownloadDocumentFileError;
  constructor(public payload: any) {}
}

export class DocumentsName implements Action {
  public readonly type = DocumentsActions.DocumentsName;
  constructor(public payload: any) {}
}
export class GetDocumentsNameSuccess implements Action {
  public readonly type = DocumentsActions.GetDocumentsNameSuccess;
  constructor(public payload: any) {}
}
export class GetDocumentsNameError implements Action {
  public readonly type = DocumentsActions.GetDocumentsNameError;
  constructor(public payload: any) {}
}
export class AddDocumentsName implements Action {
  public readonly type = DocumentsActions.AddDocumentsName;
  constructor(public payload: any) {}
}
export class AddDocumentsNameSuccess implements Action {
  public readonly type = DocumentsActions.AddDocumentsNameSuccess;
  constructor(public payload: any) {}
}
export class AddDocumentsNameError implements Action {
  public readonly type = DocumentsActions.AddDocumentsNameError;
  constructor(public payload: any) {}
}
export class GetDocumentImport implements Action {
  public readonly type = DocumentsActions.GetDocumentImport;
  constructor(public payload: any) {}
}
export class GetDocumentImportSuccess implements Action {
  public readonly type = DocumentsActions.GetDocumentImportSuccess;
  constructor(public payload: any) {}
}
export class GetDocumentImportError implements Action {
  public readonly type = DocumentsActions.GetDocumentImportError;
  constructor(public payload: any) {}
}

export class ResetUploadedDocuments implements Action {
  public readonly type = DocumentsActions.ResetUploadedDocuments;
}

export class UploadDocuments implements Action {
  public readonly type = DocumentsActions.UploadDocuments;
  constructor(public payload: any) {}
}

export class UploadDocumentsSuccess implements Action {
  public readonly type = DocumentsActions.UploadDocumentsSuccess;
  constructor(public payload: any) {}
}

export class UploadDocumentsError implements Action {
  public readonly type = DocumentsActions.UploadDocumentsError;
  constructor(public payload: any) {}
}

export class RemoveDocument implements Action {
  public readonly type = DocumentsActions.RemoveDocument;
  constructor(public payload: any) {}
}
export class RemoveDocumentSuccess implements Action {
  public readonly type = DocumentsActions.RemoveDocumentSuccess;
  constructor(public payload: any) {}
}
export class RemoveDocumentError implements Action {
  public readonly type = DocumentsActions.RemoveDocumentError;
  constructor(public payload: any) {}
}

export class GetAllRecords implements Action {
  public readonly type = DocumentsActions.GetAllRecords;
  constructor(public payload: { companyId: number }) {}
}

export class GetAllRecordsSuccess implements Action {
  public readonly type = DocumentsActions.GetAllRecordsSuccess;
  constructor(public payload: Record[]) {}
}

export class GetAllRecordsError implements Action {
  public readonly type = DocumentsActions.GetAllRecordsError;
  constructor(public payload: any) {}
}

export class GetAllRecordsReset implements Action {
  public readonly type = DocumentsActions.GetAllRecordsReset;
}

export class AcknowledgeDocument implements Action {
  public readonly type = DocumentsActions.AcknowledgeDocument;
  constructor(public payload: {
    documentId: number
  }) {}
}

export class AcknowledgeDocumentSuccess implements Action {
  public readonly type = DocumentsActions.AcknowledgeDocumentSuccess;
}

export class AcknowledgeDocumentError implements Action {
  public readonly type = DocumentsActions.ErrorAcknowledgeDocument;
}

export class AcknowledgeDocumentReset implements Action {
  public readonly type = DocumentsActions.AcknowledgeDocumentReset
}

export type DocumentsAction =
  | GetAllDocuments
  | GetAllDocumentsSuccess
  | GetAllDocumentsError
  | AddDocuments
  | GetAddDocumentsSuccess
  | GetAddDocumentsError
  | EditDocuments
  | GetEditDocumentsSuccess
  | GetEditDocumentsError
  | DocumentsType
  | GetDocumentsTypeSuccess
  | GetDocumentsTypeError
  | GetDocumentsTypeReset
  | AddDocumentsType
  | AddDocumentsTypeSuccess
  | AddDocumentsTypeError
  | GetTypeRecord
  | GetTypeRecordSuccess
  | GetTypeRecordError
  | GetDocumentsById
  | GetDocumentsByIdSuccess
  | GetDocumentsByIdError
  | GetDocumentsByIdReset
  | GetDocumentContentById
  | GetDocumentContentByIdSuccess
  | GetDocumentContentByIdError
  | GetDocumentContentByIdReset
  | GetDocumentCount
  | GetDocumentCountSuccess
  | GetDocumentCountError
  | GetDocumentSearchError
  | GetDocumentSearchSuccess
  | GetDocumentSearch
  | DownloadDocumentFile
  | DownloadDocumentFileSuccess
  | DownloadDocumentFileError
  | DocumentsName
  | GetDocumentsNameSuccess
  | GetDocumentsNameError
  | AddDocumentsName
  | AddDocumentsNameSuccess
  | AddDocumentsNameError
  | GetDocumentImport
  | GetDocumentImportSuccess
  | GetDocumentImportError
  | ResetUploadedDocuments
  | UploadDocuments
  | UploadDocumentsSuccess
  | UploadDocumentsError
  | RemoveDocument
  | RemoveDocumentSuccess
  | RemoveDocumentError
  | GetAllRecords
  | GetAllRecordsError
  | GetAllRecordsSuccess
  | GetAllRecordsReset
  | ResetAddDocuments
  | ResetEditDocument
  | AcknowledgeDocument
  | AcknowledgeDocumentSuccess
  | AcknowledgeDocumentError
  | AcknowledgeDocumentReset;
